import React from "react"
import PropTypes from "prop-types"
import { Link as GatsbyLink } from "gatsby"
import styled from "styled-components"

const StyledLink = styled(GatsbyLink)``

const StyledLinkInner = styled.span`
  display: flex;
  align-items: center;

  ${(props) =>
    props.inline &&
    `
      display: inline-flex;
    `}

  svg {
    margin: 0 0 0 0.4em;
  }
`

function Link({ children, blank, inline, ...props }) {
  console.log(props)
  if (blank)
    return (
      <a href={props.to} target="_blank" rel="noreferrer noopener">
        <StyledLinkInner inline={inline}>{children}</StyledLinkInner>
      </a>
    )
  return (
    <StyledLink {...props}>
      <StyledLinkInner inline={inline}>{children}</StyledLinkInner>
    </StyledLink>
  )
}

export default Link

Link.defaultProps = {
  blank: false,
  inline: false,
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  blank: PropTypes.bool,
  inline: PropTypes.bool,
}
